// extracted by mini-css-extract-plugin
export default {"payment":"Payment_payment__Qa8yI"};